import LoadSources from 'constants/LoadSources';

// Contains mapping between load source & the formatted name to display on the frontend
export const MappedBrokerNames = {
  [LoadSources.CH_ROBINSON]: 'CH Robinson',
};
